module.exports = __webpack_public_path__ + "static/media/space.a21c0d28.jpg";